export const RULE_STATUS = [
    {
        name: 'Active',
        value: 'active',
    },
    {
        name: 'Deactive',
        value: 'deactive',
    },
]

export const SHIPPING_BOX_TYPE = [
    {
        name: 'Shipping box',
        value: 'default',
    },
    {
        name: 'Combination box',
        value: 'combination',
    },
    {
        name: 'Split box',
        value: 'split',
    },
]